import Gallery from "webPage/Gallery";

export default function handleTestimonialSliders() {
    $('.js-testimonial-gallery').each(function () {
        handleTestimonialSlider($(this));
    });
}

function handleTestimonialSlider($element) {
    let gallery = new Gallery($element, {
        itemClass: "slider__slide",
        pipClass: "pip",
        itemsClass: "js-slides",
        animationDuration: 300,
    });

    gallerySetToSlideHeight(gallery, 0, false);

    gallery.on('transitionStart', ({from, to}) => {
        gallerySetToSlideHeight(gallery, to);
    });

    $(window).on('resize', () => {
        if ($(window).outerWidth() >= 1024) {
            gallery.$gallery.find('.js-slides').css({'height': ''});
        }

        let index = gallery.getActiveIndex();
        gallerySetToSlideHeight(gallery, index, false);
    });
}

function gallerySetToSlideHeight(gallery, index, animate = true) {
    if ($(window).outerWidth() >= 1024) {
        gallery.$gallery.find('.js-slides').css({'height': ''});
        return;
    }

    let new_height = gallery.getItem(index).innerHeight();

    if (animate) {
        gallery.$gallery.find('.js-slides').stop().animate({
            height: new_height,
        }, {
            duration: 400,
        });
    } else {
        gallery.$gallery.find('.js-slides').stop().css({'height': new_height});
    }
}
